import { render } from "./HomeAdmin.vue?vue&type=template&id=0b05c3e0&scoped=true"
import script from "./HomeAdmin.vue?vue&type=script&lang=js"
export * from "./HomeAdmin.vue?vue&type=script&lang=js"

import "./HomeAdmin.vue?vue&type=style&index=0&id=0b05c3e0&scoped=true&lang=css"

import exportComponent from "D:\\Accen_GITS\\Gestion-conge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b05c3e0"]])

export default __exports__